"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.redirectToLoginPolicy = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

/**
 *  Makes sure that the user is redirected to login if their session expires on the server.
 *  We do this here because we want to redirect on user activity, and we define that as any request to the server.
 **/
var redirectToLoginPolicy = function redirectToLoginPolicy(isAuthenticated) {
  return {
    create: function create(nextPolicy) {
      return {
        sendRequest: function () {
          var _sendRequest = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(httpRequest) {
            var response, isAuthOnServerHeader, isAuthOnServer;
            return _regenerator["default"].wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return nextPolicy.sendRequest(httpRequest);

                  case 2:
                    response = _context.sent;

                    if (isAuthenticated) {
                      _context.next = 5;
                      break;
                    }

                    return _context.abrupt("return", response);

                  case 5:
                    isAuthOnServerHeader = response.headers.get("x-is-authenticated-on-server");

                    if (isAuthOnServerHeader) {
                      _context.next = 8;
                      break;
                    }

                    return _context.abrupt("return", response);

                  case 8:
                    isAuthOnServer = JSON.parse(isAuthOnServerHeader.toLowerCase());

                    if (!isAuthOnServer) {
                      window.location.href = "/Account/SignIn?returnUrl=".concat(encodeURIComponent(window.location.pathname));
                    }

                    return _context.abrupt("return", response);

                  case 11:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          function sendRequest(_x) {
            return _sendRequest.apply(this, arguments);
          }

          return sendRequest;
        }()
      };
    }
  };
};

exports.redirectToLoginPolicy = redirectToLoginPolicy;